import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue)

// import Vue from 'vue';
// import bAlert from 'bootstrap-vue/es/components/alert/alert';
// import bBadge from 'bootstrap-vue/es/components/badge/badge';
// import bButton from 'bootstrap-vue/es/components/button/button';
// import bCard from 'bootstrap-vue/es/components/card/card';
// import bCardBody from 'bootstrap-vue/es/components/card/card-body';
// import bCardFooter from 'bootstrap-vue/es/components/card/card-footer';
// import bCardGroup from 'bootstrap-vue/es/components/card/card-group';
// import bCardHeader from 'bootstrap-vue/es/components/card/card-header';
// import bCardImg from 'bootstrap-vue/es/components/card/card-img';
// import bCollapse from 'bootstrap-vue/es/components/collapse/collapse';
// import bDropdown from 'bootstrap-vue/es/components/dropdown/dropdown';
// import bDropdownDivider from 'bootstrap-vue/es/components/dropdown/dropdown-divider';
// import bDropdownHeader from 'bootstrap-vue/es/components/dropdown/dropdown-header';
// import bDropdownItem from 'bootstrap-vue/es/components/dropdown/dropdown-item';
// import bDropdownItemButton from 'bootstrap-vue/es/components/dropdown/dropdown-item-button';
// import bEmbed from 'bootstrap-vue/es/components/embed/embed';
// import bFormText from 'bootstrap-vue/es/components/form/form-text';
// import bFormRadio from 'bootstrap-vue/es/components/form-radio/form-radio';
// import bFormRadioGroup from 'bootstrap-vue/es/components/form-radio/form-radio-group';
// import bFormInput from 'bootstrap-vue/es/components/form-input/form-input';
// import bFormTextarea from 'bootstrap-vue/es/components/form-textarea/form-textarea';
// import bFormFile from 'bootstrap-vue/es/components/form-file/form-file';
// import bFormSelect from 'bootstrap-vue/es/components/form-select/form-select';
// import bImg from 'bootstrap-vue/es/components/image/img';
// import bImgLazy from 'bootstrap-vue/es/components/image/img-lazy';
// import bInputGroup from 'bootstrap-vue/es/components/input-group/input-group';
// import bInputGroupAddon from 'bootstrap-vue/es/components/input-group/input-group-addon';
// import bInputGroupAppend from 'bootstrap-vue/es/components/input-group/input-group-append';
// import bInputGroupPrepend from 'bootstrap-vue/es/components/input-group/input-group-prepend';
// import bInputGroupText from 'bootstrap-vue/es/components/input-group/input-group-text';
// import bLink from 'bootstrap-vue/es/components/link/link';
// import bNav from 'bootstrap-vue/es/components/nav/nav';
// import bNavForm from 'bootstrap-vue/es/components/nav/nav-form';
// import bNavItem from 'bootstrap-vue/es/components/nav/nav-item';
// import bNavItemDropdown from 'bootstrap-vue/es/components/nav/nav-item-dropdown';
// import bNavText from 'bootstrap-vue/es/components/nav/nav-text';
// import bNavbar from 'bootstrap-vue/es/components/navbar/navbar';
// import bNavbarBrand from 'bootstrap-vue/es/components/navbar/navbar-brand';
// import bNavbardNav from 'bootstrap-vue/es/components/navbar/navbar-nav';
// import bNavbardToggle from 'bootstrap-vue/es/components/navbar/navbar-toggle';
// import bTable from 'bootstrap-vue/es/components/table/table';
// import bTab from 'bootstrap-vue/es/components/tabs/tab';
// import bTabs from 'bootstrap-vue/es/components/tabs/tabs';
// import bTooltip from 'bootstrap-vue/es/components/tooltip/tooltip';
// import vBToggle from 'bootstrap-vue/es/directives/toggle/toggle';
// import vBPopover from 'bootstrap-vue/es/directives/popover/popover';
// import vPagination from 'bootstrap-vue/es/components/pagination/pagination';
// import bProgress from 'bootstrap-vue/es/components/progress/progress';
// import bProgressBar from 'bootstrap-vue/es/components/progress/progress-bar';
// import bFormCheckboxGroup from 'bootstrap-vue/es/components/form-checkbox/form-checkbox-group';
// import bFormCheckbox from 'bootstrap-vue/es/components/form-checkbox/form-checkbox';
// import bFormGroup from 'bootstrap-vue/es/components/form-group/form-group';
//
// Vue.component('b-alert', bAlert);
// Vue.component('b-badge', bBadge);
// //Vue.component('b-breadcrumb', bBreadcrumb);
// //Vue.component('b-breadcrumb-item', bBreadcrumbItem);
// //Vue.component('b-breadcrumb-link', bBreadcrumbLink);
// Vue.component('b-button', bButton);
// //Vue.component('b-button-close', bButtonClose);
// //Vue.component('b-button-group', bButtonGroup);
// //Vue.component('b-button-toolbar', bButtonToolbar);
// Vue.component('b-card', bCard);
// Vue.component('b-card-body', bCardBody);
// Vue.component('b-card-footer', bCardFooter);
// Vue.component('b-card-group', bCardGroup);
// Vue.component('b-card-header', bCardHeader);
// Vue.component('b-card-img', bCardImg);
// //Vue.component('b-carousel', bCarousel);
// //Vue.component('b-carousel-slide', bCarouselSlide);
// Vue.component('b-collapse', bCollapse);
// Vue.component('b-dropdown', bDropdown);
// Vue.component('b-dropdown-divider', bDropdownDivider);
// Vue.component('b-dropdown-header', bDropdownHeader);
// Vue.component('b-dropdown-item', bDropdownItem);
// Vue.component('b-dropdown-button', bDropdownItemButton);
// Vue.component('b-embed', bEmbed);
// //Vue.component('b-form', bForm);
// //Vue.component('b-form-invalid-feedback', bFormInvalidFeedback);
// //Vue.component('b-form-row', bFormRow);
// Vue.component('b-form-text', bFormText);
// //Vue.component('b-form-valid-feedback', bFormValidFeedback);
// Vue.component('b-form-group', bFormGroup);
// Vue.component('b-form-checkbox', bFormCheckbox);
// Vue.component('b-form-checkbox-group', bFormCheckboxGroup);
// Vue.component('b-form-radio', bFormRadio);
// Vue.component('b-form-radio-group', bFormRadioGroup);
// Vue.component('b-form-input', bFormInput);
// Vue.component('b-form-textarea', bFormTextarea);
// Vue.component('b-form-file', bFormFile);
// Vue.component('b-form-select', bFormSelect);
// Vue.component('b-img', bImg);
// Vue.component('b-img-lazy', bImgLazy);
// Vue.component('b-input-group', bInputGroup);
// Vue.component('b-input-group-addon', bInputGroupAddon);
// Vue.component('b-input-group-append', bInputGroupAppend);
// Vue.component('b-input-group-prepend', bInputGroupPrepend);
// Vue.component('b-input-group-text', bInputGroupText);
// //Vue.component('b-jumbotron', bJumbotron);
// //Vue.component('b-container', bContainer);
// //Vue.component('b-col', bCol);
// //Vue.component('b-row', bRow);
// Vue.component('b-link', bLink);
// //Vue.component('b-list-group', bListGroup);
// //Vue.component('b-list-group-item', bListGroupItem);
// //Vue.component('b-media', bMedia);
// //Vue.component('b-media-aside', bMediaAside);
// //Vue.component('b-media-body', bMediaBody);
// //Vue.component('b-modal', bModal);
// Vue.component('b-nav', bNav);
// Vue.component('b-nav-form', bNavForm);
// Vue.component('b-nav-item', bNavItem);
// Vue.component('b-nav-item-dropdown', bNavItemDropdown);
// Vue.component('b-nav-text', bNavText);
// Vue.component('b-navbar', bNavbar);
// Vue.component('b-navbar-brand', bNavbarBrand);
// Vue.component('b-navbar-nav', bNavbardNav);
// Vue.component('b-navbar-toggle', bNavbardToggle);
// Vue.component('b-pagination', vPagination);
// // Vue.component('b-pagination-nav', bPaginationNav);
// // Vue.component('b-popover', bPopover);
// Vue.component('b-progress', bProgress);
// Vue.component('b-progress-bar', bProgressBar);
// Vue.component('b-table', bTable);
// Vue.component('b-tab', bTab);
// Vue.component('b-tabs', bTabs);
// Vue.component('b-tooltip', bTooltip);
//
// Vue.directive('b-toggle', vBToggle);
//
// Vue.directive('b-popover', vBPopover);
//
